// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
//YDUI 框架
import YDUI from 'vue-ydui'; /* 相当于import YDUI from 'vue-ydui/ydui.rem.js' */
import 'vue-ydui/dist/ydui.rem.css'; /*使用rem*/
/* 使用px：import 'vue-ydui/dist/ydui.px.css'; */
Vue.use(YDUI);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import wx from "weixin-jsapi"; 

// 如此配置即可
// uni.$u.config.unit = 'rpx'


Vue.use(vueSwiper)
// import CarPlate from 'vue-carplate';
// Vue.use(CarPlate);
Vue.config.productionTip = false
Vue.prototype.wx = wx

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js